import { config } from '../../config';

import type { StoreTokensParams } from './store-tokens.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Stores provided tokens in the local storage (hybrid flow).
 */
export function storeHybridFlowTokens(params: StoreTokensParams) {
  const { accessToken, refreshToken } = params;

  if (accessToken) {
    localStorage.setItem(config.hybridFlowAccessTokenStorageKey, accessToken);
  }

  if (refreshToken) {
    localStorage.setItem(config.hybridFlowRefreshTokenStorageKey, refreshToken);
  }
}
